<template>
  <div :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY + 'orderNo')">
              <a-input :placeholder="$t('enter') + ' ' + transformStringToLow($t(I18N_KEY + 'orderNo'))" v-model="queryParam.orderNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('phoneNo')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('phoneNo'))"
                v-model="queryParam.mobileNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="$t('name')">
              <a-input
                :placeholder="$t('enter') + ' ' + transformStringToLow($t('names'))"
                v-model="queryParam.names"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="'order id encrypt'">
              <a-input :placeholder="$t('enter') + ' order id encrypt'" v-model="queryParam.orderIdAes"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
       <!-- Create payment order with specified amount -->
       <a-modal :width="700" v-model:visible="visibleAmount" :title="$t('repaycert.enterAmount')">

        <a-row style="margin-bottom: 20px;">
          <a-col :md="14" :sm="8"  style="display: flex; align-items: center;">
            <span style="display: inline-block; width: 70px;">  Amount:</span>
            <a-input v-model="zdAmt" style="width: 196px;" type="number" />
          </a-col>
        </a-row>
        <a-row>
          <a-col :md="14" :sm="8" style="display: flex; align-items: center;">
            <span style="display: inline-block; width: 70px;">Payment Type:</span>
            <a-select  style='width: 203px' allowClear v-model='channel'>
                <a-select-option :value="value"  v-for="(value , key) in payChannelList" :key="key">{{ key }}</a-select-option>
              </a-select>
          </a-col>
        </a-row>
        <div v-if="zdAmountUrl">
          
          <div style="display: flex; align-items: center;font-size: 14px; margin: 20px 0px;">
            <div>H5 Link:</div>
            <div style="margin:0px 20px;">{{ zdAmountUrl }}</div>
            <a-button  key="submit" type="primary" @click="copy(zdAmountUrl)">{{$t('teleMarket.copy')}}</a-button>
          </div>
          
        </div>
        <div v-if="payOutId">
          
          <div style="display: flex; align-items: center; font-size: 14px; margin-bottom: 20px;">
            <div>Payment Order No.:</div>
            <div style="margin: 0px 20px;">{{ payOutId }}</div>
            <a-button  key="submit" type="primary" @click="copy(payOutId)">{{$t('teleMarket.copy')}}</a-button>
          </div>
        </div>
        <template #footer>
          <a-button key="back" @click="handleCancelAmount">{{$t('cancel')}}</a-button>
          <a-button key="submit" type="primary" :loading="loadingAmt" @click="submitAmount()">{{$t('confirm')}}</a-button>
        </template>
      </a-modal>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="{ x: 2300, y: 2000 }"
        :pagination="false"
        :loading="loading"
        bordered>
        <Dict slot="loanStatus" slot-scope="text" :dict-code="DICT_CODE.LOAN_STATUS" :value="text"/>
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS" :value="text"/>
        <Dict slot="settleStatus" slot-scope="text" :dict-code="DICT_CODE.INSTALLMENT_SETTLE_STATUS" :value="text"/>
        <Dict slot="overdueStatus" slot-scope="text" :dict-code="DICT_CODE.OVERDUE_STATUS" :value="text"/>
        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">{{ $t('view') }}</a>
          <a @click="handleOrderDetail(record)" v-if='record.approvalStatus == 4 && record.loanStatus == 1'>
            Repayment Plan
          </a>
          <a @click="createRepayUrl(record)" v-if='record.approvalStatus == 4 && record.loanStatus == 1'>
            Repayment Link
          </a>
          <a type="primary" size="small" @click="zdAmount(record)" style="margin: 10px"
            >{{$t('repaycert.createRepayOrder')}}</a>
<!--          <a @click="handleLoan(record.id)" v-if='record.approvalStatus == 4 && record.loanStatus == 0'>-->
<!--            Loan-->
<!--          </a>-->
<!--          <a @click="handleOrderEdit(record)" v-if='record.approvalStatus != 4'>-->
<!--            Order edit-->
<!--          </a>-->
<!--          <a @click="handleEdit(record)" v-if='record.approvalStatus == 4 && record.loanStatus == 1 && record.settleStatus == 0'>-->
<!--            Edit repayment plan-->
<!--          </a>-->
        </span>

<!--        <a-table-->
<!--          slot="expandedRowRender"-->
<!--          slot-scope="text"-->
<!--          ref="table"-->
<!--          size="middle"-->
<!--          :columns="innerColumns"-->
<!--          :data-source="text.repayPlans"-->
<!--          :loading="loading"-->
<!--          :pagination="false"-->
<!--          bordered>-->
<!--        </a-table>-->
      </a-table>
      <div style="margin-top: 15px; text-align: right;">
          <v-pagination
              v-if="total"
              :page-num="form.pageNum"
              :page-size="form.pageSize"
              :total="total"
              @change="handleTableChange" />
      </div>
    </div>
    <v-modal
        v-model="visible"
        :title="$t(I18N_KEY + 'orderDetail')">
        <div style="padding: 20px;">
            <order-detail v-if="visible" :orderId="orderId" :custInfoId="custInfoId"/>
        </div>
    </v-modal>
    <TestInstallOrderModal ref="modalForm" @ok="modalFormOk"></TestInstallOrderModal>
    <TestInstallOrderModalT ref="modalFormT" @ok="modalFormOkT"></TestInstallOrderModalT>
    <TestInstallOrderListModal ref="modalFormF"></TestInstallOrderListModal>

    <a-modal
      v-model:visible="visibleRepayUrlCard"
      :title="$t('createRepayUrl')"
      ok-text="Confirm"
      cancel-text="Cancel"
      @ok="hideModal"
    >
      <p>{{ repayUrl }}</p>
      <p><a-button type="primary" @click='copy(repayUrl)'>{{$t('teleMarket.copy')}}</a-button></p>
    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getPlatformAllOrderList,
  clearOrderForTest,
  getInstallmentPlatformAllOrderList,
  installmentLoanOrder, getInstallmentPlatformAllOrderListPrd, createRepayUrlFunc, createInstallmentRepayUrl
} from '@/webpublicapi/order'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import vModal from '../modules/Modal';
import OrderDetail from '../order/OrderDetail';
import moment from 'moment';
import TestInstallOrderModal from './modules/TestInstallOrderModal';
import TestInstallOrderModalT from './modules/TestInstallOrderModalT';
import TestInstallOrderListModal from './modules/TestInstallOrderListModal';

import exportFile from '@/webpublicapi/exportFile'


import {createPayOrderV2 , getPartRepayChannel} from '@/webpublicapi/CollectionAccountInfo'

const I18N_KEY = 'order.';
export default {
  name: 'TestInstallOrderList',
  components: {
    Dict,
    DictSelect,
    vModal,
    OrderDetail,
    TestInstallOrderModal,
    TestInstallOrderModalT,
    TestInstallOrderListModal,
  },
  data () {
    return {
      channel:"",
      payChannelList:[],
      payOutId:"",
      I18N_KEY,
      repayUrl:"",
      visibleRepayUrlCard: false,
      toggleSearchStatus:false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      zdAmt: '',
      zdAmountUrl: '',
      loadingAmt: false,
      visibleAmount: false,
      total: 0,
      dataSource: [],
      record1: {},
      // Query conditions
      queryParam: {
        "orderNo":"",
        "mobileNo":"",
        "names":"",
        "appssid":"",
        "aadhaarName":"",
        "createdTime":undefined,
        "loanStatus": '',
        "approvalStatus": '',
        "settleStatus": '',
        "orderIdAes": '',
      },
      loading: false,
      // Table header
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'orderNo'
        },
        {
          title: this.$t('phoneNo'),
          align: 'left',
          dataIndex: 'mobileNo'
        },
        {
          title: this.$t('names'),
          align: 'left',
          dataIndex: 'names'
        },
        {
          title: 'Batch No.',
          align: 'left',
          dataIndex: 'appSsid'
        },
        {
          title: this.$t(I18N_KEY + 'applicationAmount'),
          align: 'left',
          dataIndex: 'applyAmt'
        },
        // {
        //   title: this.$t(I18N_KEY + 'deductionFee'),
        //   align: 'left',
        //   dataIndex: 'deductionFee'
        // },
        {
          title: this.$t(I18N_KEY + 'deadline'),
          align: 'left',
          dataIndex: 'duration'
        },
        {
          title: this.$t(I18N_KEY + 'loanStatus'),
          align: 'left',
          dataIndex: 'loanStatus',
          scopedSlots: { customRender: 'loanStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'approvalStatus'),
          align: 'left',
          dataIndex: 'approvalStatus',
          scopedSlots: { customRender: 'approvalStatus' }
        },
        {
          title: this.$t(I18N_KEY + 'settlementStatus'),
          align: 'left',
          dataIndex: 'settleStatus',
          scopedSlots: { customRender: 'settleStatus' }
        },
        // {
        //   title: this.$t(I18N_KEY + 'overdueStatus'),
        //   align: 'left',
        //   dataIndex: 'overdueStatus',
        //   scopedSlots: { customRender: 'overdueStatus' }
        // },
        {
          title: this.$t(I18N_KEY + 'applicationTime'),
          align: 'left',
          dataIndex: 'createdTime'
        }
        ,
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ]
    },

    innerColumns () {
       return [
         {
           title: 'Period Count',
           align: 'left',
           dataIndex: 'period',
         },
         {
           title: 'StartDay',
           align: 'left',
           dataIndex: 'beginDate',
         },
         {
           title: 'EndDay',
           align: 'left',
           dataIndex: 'endDate'
         },
         {
           title: 'Principal',
           align: 'left',
           dataIndex: 'capital'
         },
         {
           title: 'alreadyAlsoPrincipal',
           align: 'left',
           dataIndex: 'settledCapital'
         },
         {
           title: 'Interest',
           align: 'left',
           dataIndex: 'interest'
         },
         {
           title: 'Service Fee',
           align: 'left',
           dataIndex: 'serviceFee'
         },
         {
           title: 'late fee',
           align: 'left',
           dataIndex: 'lateFee'
         },
         {
           title: 'OtherFee',
           align: 'left',
           dataIndex: 'otherFee'
         },
         {
           title: 'Deduction Fee',
           align: 'left',
           dataIndex: 'deductionFee'
         },
         {
           title: 'Status',
           align: 'left',
           dataIndex: 'status'
         }
       ]
    }
  },
  created () {
    // this.loadData(1)
  },
  methods: {
    hideModal(){},
    handleCancelAmount() {
      this.visibleAmount = false
      this.zdAmountUrl = ''
      this.zdAmt = ''
    
    },
    zdAmount(record) {
      this.loadingAmt = true
      getPartRepayChannel({key:"channel"}).then((res) => {
        if (res.code == 1000) {
          this.payChannelList=res.data
        } else {
          this.$message.error(res.msg)
        }
        this.loadingAmt = false
      })
      this.record1 = record
      this.visibleAmount = true
      // this.record1 = record
      // this.visibleAmount = true
    },
    submitAmount() {
      if (!this.zdAmt) {
        this.$message.error('Please enterAmount')
        return
      }
      this.loadingAmt = true
      let data = {
        id: this.record1.id,
        amount: this.zdAmt,
        orderType:1,
        channel:this.channel
      }
      // return console.log(this.channel)
      createPayOrderV2(data).then((res) => {
        this.loadingAmt = false
        if (res.code == 1000) {
          this.zdAmountUrl = res.data.url
          this.payOutId=res.data.payOutId
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery () {
      this.loadData(1)
    },
    loadData (arg) {
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// Query conditions
      getInstallmentPlatformAllOrderListPrd(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.total = res.data.total
          this.dataSource = res.data.rows
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
        return str && str.toLocaleLowerCase();
    },
    getQueryParams () {
      const { createdTime } = this.queryParam;
      const data = {
          ...this.queryParam,
          applyDateStart: createdTime && this.transformTime(createdTime[0]),
          applyDateEnd: createdTime && this.transformTime(createdTime[1]),
      }
      delete data.createdTime;
      var param = Object.assign({}, data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      return filterObj(param)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.orderNo = ''
      that.queryParam.mobileNo = ''
      that.queryParam.names = ''
       that.queryParam.aadhaarName = ''
       that.queryParam.createdTime = undefined;
      that.queryParam.loanStatus = ''
      that.queryParam.approvalStatus = ''
      that.queryParam.settleStatus = ''
      that.loadData(this.form.pageNum)
    },
    changeModal (visible) {
        this.visible = visible;
    },
    handleDetail (row) {
        this.orderId = row.id;
        this.custInfoId = row.custInfoId;
        this.changeModal(true);
    },
    handleOrderDetail (record) {
      this.$refs.modalFormF.edit(record)
      this.$refs.modalFormF.title = 'Detail'
    },
    createRepayUrl(record) {
      createInstallmentRepayUrl({ orderId:record.id}).then(res => {
        if(1000 != res.code){
          alert(res.msg);
          return;
        }else{
          this.repayUrl = res.data.url;
          this.visibleRepayUrlCard = true;
        }
      }).catch(e => {
        self.loading = false;
        this.$message.error(e.message);
        return;
      })
    },
    handleOrderEdit (record) {
      this.$refs.modalFormT.edit(record)
      this.$refs.modalFormT.title = 'Edit'
    },
    handleEdit (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = 'Edit'
    },
    handleLoan(id){
      const self = this;
      this.$confirm({

        title: 'HairStartDisbursement',
        // content: h => {
        //   return <div>
        //     <div>
        //       Order No:id.id
        //     </div>
        //   </div>
        // },
        onOk() {
          self.loading = true;

          installmentLoanOrder({id}).then((res) => {
            console.log(res)
            if (res.code === 1000) {
              console.log('success')
              self.$message.success(res.msg)
              self.loadData()
            } else {
              console.log('failed')
              self.$message.error(res.msg)
              self.loadData();
            }
          }).catch(e => {
            self.loading = false;
            self.$message.error(e.message);
          })
        },
      });

    },
    handleClear(id){
      clearOrderForTest({id}).then((res) => {
        if (res.code === 1000) {
          this.$message.success(res.msg)
          this.loadData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    downLoadData (record, type) {
      const file = {
        fileUrl: '/api/web/webpublic/order/test/getJsonData?orderId=' + record.id + '&type=' + type ,
        fileName: 'jsonForCustExcel.txt',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    // modelCallback
    modalFormOk () {
      this.loadData()
    },
    modalFormOkT () {
      this.loadData()
    },
    copy(e) { //Copy method
      let input = document.createElement('input')
      input.value = e
      document.body.appendChild(input)
      input.select()
      document.execCommand("copy")
      document.body.removeChild(input)
      this.$message.info("copy success");
    }
  }
}
</script>
<style lang="less" scoped>
 @import "~@/assets/less/common.less";
</style>
